export default __webpack_public_path__ + "static/media/entrance_icon_black.1eba1387.svg";